import { mix } from 'popmotion';

function tweenAxis(target, prev, next, p) {
    target.min = mix(prev.min, next.min, p);
    target.max = mix(prev.max, next.max, p);
}

export { tweenAxis };



//////////////////
// WEBPACK FOOTER
// ./node_modules/framer-motion/dist/es/motion/features/layout/utils.js
// module id = 203
// module chunks = 0